import { Injectable } from '@angular/core';

@Injectable()
export class GoogleMapNormalizeService {
  // normalize and rotate if latitude is out of range
  private normalizeAndRotateLatitude(latitude: number) {
    if (latitude < -90) {
      return (latitude % 90) + 90;
    }
    if (latitude > 90) {
      return (latitude % 90) - 90;
    }
    return latitude;
  }

  // normalize and rotate latitude
  private normalizeAndRotateLongitude(longitude: number) {
    if (longitude < -180) {
      return ((longitude + 180) % 360) + 180;
    }
    if (longitude > 180) {
      return ((longitude - 180) % 360) - 180;
    }
    return longitude;
  }

  // normalizing the coordinates is required in case when the pair is out of their default possible range
  // latitude default range: -90 -> +90 degrees
  // longitude default range: -180 -> +180 degrees
  normalizeCoordinates(latitude: string | number, longitude: string | number) {
    const normalizedLatitude = this.normalizeAndRotateLatitude(+latitude);
    const normalizedLongitude = this.normalizeAndRotateLongitude(+longitude);
    return { lat: normalizedLatitude, lng: normalizedLongitude };
  }
}
